module.exports = __webpack_public_path__ + "static/img/miura_03.c69b078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/miura_03.png
// module id = gb4h
// module chunks = 0